import React from 'react';
import ReactDOMServer from 'react-dom/server';
import SVGPage from './components/SVGPage';
// import Base from './components/Base';

export default (scene, options) => {
  const rawSvg = ReactDOMServer.renderToStaticMarkup(<SVGPage {...scene} options={options} />);
  return rawSvg;
};
